import React from 'react';

import { useTranslation } from 'react-i18next';
import { Mail } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { PageContainer } from '../../../common/components/PageContainer';
import { useTabParam } from '../../../common/hooks/use-tab-param.hook';
import { EmailTemplatesPage } from './email-templates.page';
import { EmailSettingsPage } from './email-settings.page';

const TABS = [
  { key: 'templates', labelKey: 'EMAIL_SETTINGS.TAB_TEMPLATES' },
  { key: 'smtp', labelKey: 'EMAIL_SETTINGS.TAB_SMTP' },
] as const;
const TAB_KEYS = TABS.map((tab) => tab.key);
type EmailSettingsTab = (typeof TAB_KEYS)[number];

const EmailSettingsLayout: React.FC = () => {
  const { t } = useTranslation();
  // /marketing/email/settings?tab=smtp — one page, the tab in the query.
  const [activeKey, setTab] = useTabParam<EmailSettingsTab>(TAB_KEYS);
  const handleChange = (key: string) => setTab(key as EmailSettingsTab);

  return (
    <PageContainer breadcrumbs={[
      { label: t('SIDEBAR.MARKETING.TITLE') },
      { label: t('SIDEBAR.MARKETING.EMAIL_MARKETING'), icon: <Mail className="size-5" />, href: '/marketing/email/compose' },
      { label: t('SIDEBAR.MARKETING.EMAIL_SETTINGS') }
    ]}>
      <div className="mb-4 inline-block">
        <Tabs value={activeKey} onValueChange={handleChange}>
          <TabsList className="h-9">
            {TABS.map((tab) => (
              <TabsTrigger key={tab.key} value={tab.key} className="px-3 text-sm">
                {t(tab.labelKey)}
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>
      </div>
      <div>
        {activeKey === 'smtp' ? <EmailSettingsPage /> : <EmailTemplatesPage />}
      </div>
    </PageContainer>
  );
};

export default EmailSettingsLayout;
